import script from "./DataTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataTable.vue?vue&type=script&lang=ts&setup=true"

import "./DataTable.vue?vue&type=style&index=0&id=99d76cf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99d76cf6"]])

export default __exports__